'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  Home,
  BookOpen,
  UserCog,
  HelpCircle,
  Library,
  LibraryBig,
  NotebookPen,
  ChartColumnBig,
  Vault,
} from 'lucide-react';
import { useAuth } from '@/context/auth-context';

import { cn } from '@/lib/utils';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from '@/components/ui/sidebar';

const navItems = [
  {
    href: '/',
    icon: Home,
    label: 'Home',
  },
  {
    href: '/writing/task-1',
    icon: ChartColumnBig,
    label: 'Task 1',
  },
  {
    href: '/writing/task-2',
    icon: NotebookPen,
    label: 'Task 2',
  },
  {
    href: '/knowledge',
    icon: BookOpen,
    label: 'My Knowledge',
  },
  {
    href: '/knowledge-library',
    icon: Library,
    label: 'Knowledge Library',
  },
  {
    href: '/task-bank',
    icon: Vault,
    label: 'Task Bank',
  },
  {
    href: '/user-guide',
    icon: HelpCircle,
    label: 'User Guide',
  },
];

// Admin specific navigation items
const adminNavItems = [
  {
    href: '/admin/users',
    icon: UserCog,
    label: 'Manage Users',
  },
  {
    href: '/admin/knowledge-library',
    icon: LibraryBig,
    label: 'Manage Library',
  },
  {
    href: '/admin/task-bank',
    icon: Vault,
    label: 'Manage Task Bank',
  },
];

export default function NavigationSection() {
  const pathname = usePathname();
  const { userProfile } = useAuth();
  const isAdmin = userProfile?.role === 'admin';

  return (
    <SidebarGroup className='flex-grow'>
      <SidebarGroupContent>
        <SidebarMenu>
          {navItems.map((item) => {
            const isActive = pathname === item.href;
            return (
              <SidebarMenuItem key={item.href}>
                <SidebarMenuButton
                  asChild
                  tooltip={item.label}
                  className={cn(
                    'justify-start gap-2',
                    isActive && 'bg-muted font-semibold'
                  )}
                >
                  <Link href={item.href}>
                    <item.icon />
                    <span>{item.label}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>

        {isAdmin && (
          <>
            <SidebarGroupLabel className='mt-4 group-data-[collapsible=icon]:hidden'>
              Admin Panel
            </SidebarGroupLabel>
            <SidebarMenu>
              {adminNavItems.map((item) => {
                const isActive = pathname.startsWith(item.href);
                return (
                  <SidebarMenuItem key={item.href}>
                    <SidebarMenuButton
                      asChild
                      tooltip={item.label}
                      className={cn(
                        'justify-start gap-2',
                        isActive && 'bg-muted font-semibold'
                      )}
                    >
                      <Link href={item.href}>
                        <item.icon />
                        <span>{item.label}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </>
        )}
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
